import { View } from "@dhx/ts-common/view";
import { getPageInlineCss, getPageLinksCss } from "@dhx/ts-common/html";

export class Exporter {
	constructor(private _name: string, private _version: string, private _view: View) {}

	pdf(config: any) {
		this._rawExport(config, "pdf", this._view);
	}

	png(config) {
		this._rawExport(config, "png", this._view);
	}

	protected _rawExport(config: any, mode: string, view: View) {
		const exportStyles = view.config.exportStyles;
		config = config || {};
		config.url = config.url || "https://export.dhtmlx.ru/" + this._name + "/" + mode;
		config.url += "/" + this._version;
		let styles = "";
		if (exportStyles === true) {
			styles = `${getPageLinksCss()}<style>${getPageInlineCss()}</style>`;
		} else if (exportStyles.length) {
			styles = `${getPageLinksCss(exportStyles)}`;
		}
		const html = `
				${styles}
				${(view.getRootView().node.el.parentNode as any).innerHTML}
			`.replace(/(src|href)=("(.+?\.(jpeg|jpg|png|apng|gif|svg|bmp|ico))")/gm, match => {
			if (match.includes("://")) {
				return match;
			}
			const initialLink = match.replace(/(src|href)="/, "").replace('"', "");
			return /(src|href)="/.exec(match)[0] + this._normalizeLink(initialLink) + '"';
		});

		const t = document.createElement("form");
		t.setAttribute("method", "POST");
		t.setAttribute("action", config.url);
		t.innerHTML = `<input type="hidden" name="raw"><input type="hidden" name="config">`;
		(t.childNodes[0] as HTMLInputElement).value = html;
		(t.childNodes[1] as HTMLInputElement).value = JSON.stringify(config);

		document.body.appendChild(t);
		t.submit();

		setTimeout(() => {
			t.parentNode.removeChild(t);
		}, 100);
	}

	private _normalizeLink(link) {
		const locationParts = window.location.pathname.split("/");
		if (locationParts[0] === "") {
			locationParts.shift();
			locationParts.pop();
		}
		return window.location.origin + "/" + locationParts.join("/") + (link[0] !== "/" ? "/" + link : link);
	}
}
